import { render, staticRenderFns } from "./Minimal.vue?vue&type=template&id=31e46608&scoped=true&"
import script from "./Minimal.vue?vue&type=script&lang=js&"
export * from "./Minimal.vue?vue&type=script&lang=js&"
import style0 from "./Minimal.vue?vue&type=style&index=0&id=31e46608&lang=scss&scoped=true&"
import style1 from "./Minimal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e46608",
  null
  
)

export default component.exports